import React from "react";

// Future component for OWNER-APPROVED indicative pricing. Renders no dollar value until every
// approval field is supplied. Never pass invented values.
export type ApprovedPricing = {
  fromPrice: string;
  designRevision: string;
  scope: string;
  inclusions: string;
  exclusions: string;
  gstTreatment: string;
  location: string;
  validUntil: string;
};
type IndicativePricingProps = {
  designName: string;
  approved?: ApprovedPricing;
};
export function IndicativePricing({
  designName,
  approved
}: IndicativePricingProps) {
  if (!approved) {
    return <div className="border-l-2 border-ocean bg-white p-6" data-id="element-550" data-mp="1n9202kbr0ul2">
        <h3 className="text-lg font-semibold" data-id="element-551" data-mp="2181t046anvn1">Pricing for {designName}</h3>
        <p className="mt-2 text-[16px] leading-relaxed text-slate" data-id="element-552" data-mp="1w748hkxtapid">
          Your build price depends on the design, your site, your selections and the agreed scope. Talk with our team about
          your plans so we can explain the next steps towards project-specific costing.
        </p>
      </div>;
  }
  return <div className="border-l-2 border-ocean bg-white p-6" data-id="element-553" data-mp="2rt0lduto76fg">
      <h3 className="text-lg font-semibold" data-id="element-554" data-mp="2vum5o18jamzo">Indicative pricing for {designName}</h3>
      <p className="mt-2 font-heading text-3xl font-semibold" data-id="element-555" data-mp="30u8gy54sxt5u">From {approved.fromPrice}</p>
      <dl className="mt-4 grid gap-2 text-sm text-slate sm:grid-cols-2" data-id="element-556" data-mp="35tbe73ejiv39">
        <div data-id="element-557" data-mp="35sjsqlenqdqp"><dt className="font-medium text-charcoal" data-id="element-558" data-mp="35r8qiq0v1e1p">Design revision</dt><dd data-id="element-559" data-mp="286m5ybt8vm8y">{approved.designRevision}</dd></div>
        <div data-id="element-560" data-mp="283q6gj1r0pie"><dt className="font-medium text-charcoal" data-id="element-561" data-mp="283q7mmdhivjz">Scope</dt><dd data-id="element-562" data-mp="2d5p8nplr5gdr">{approved.scope}</dd></div>
        <div data-id="element-563" data-mp="2d2kwo621pgcj"><dt className="font-medium text-charcoal" data-id="element-564" data-mp="2d2b7ulsqlf8f">Inclusions</dt><dd data-id="element-565" data-mp="2i2yxb31bho0j">{approved.inclusions}</dd></div>
        <div data-id="element-566" data-mp="2i1xjiqsx2nf4"><dt className="font-medium text-charcoal" data-id="element-567" data-mp="2mugyns795qm1">Exclusions</dt><dd data-id="element-568" data-mp="2mv8v158obsdd">{approved.exclusions}</dd></div>
        <div data-id="element-569" data-mp="1pf3448ayie8i"><dt className="font-medium text-charcoal" data-id="element-570" data-mp="1pf32y4z8086x">GST</dt><dd data-id="element-571" data-mp="1pea5jum5iv1g">{approved.gstTreatment}</dd></div>
        <div data-id="element-572" data-mp="1ue68dqj44gff"><dt className="font-medium text-charcoal" data-id="element-573" data-mp="1ue66fkzjy6cs">Location</dt><dd data-id="element-574" data-mp="1uclgk8o6nbl9">{approved.location}</dd></div>
        <div data-id="element-575" data-mp="1mdgq5mictym6"><dt className="font-medium text-charcoal" data-id="element-576" data-mp="1md8cvtibkrag">Valid until</dt><dd data-id="element-577" data-mp="1mbniq4zx3ad4">{approved.validUntil}</dd></div>
      </dl>
    </div>;
}